export default {
  title: "計算模板",
  filter: {
    name: "模板名稱",
    namePlaceholder: "請輸入模板名稱",
    type: "模板類型",
    typePlaceholder: "請選擇模板類型",
  },
  table: {
    name: "模板名稱",
    type: "類型",
    createdAt: "建立時間",
    actions: "操作",
    single: "單次計算",
    batch: "批次計算",
  },
  action: {
    edit: "編輯名稱",
    use: "使用",
  },
  modal: {
    editTitle: "編輯模板名稱",
    nameLabel: "模板名稱",
    namePlaceholder: "請輸入模板名稱",
    nameRequired: "請輸入模板名稱",
  },
  deleteConfirm: {
    title: "刪除模板",
    content: "確定要刪除此模板嗎？",
  },
  message: {
    fetchFailed: "獲取模板列表失敗",
    updateSuccess: "模板名稱更新成功",
    updateFailed: "更新失敗",
    deleteSuccess: "模板刪除成功",
  },
};
